// 职业测评信息
import React from 'react';
import { Button, Form } from 'antd';

import Config from '../../config/Config';
import Widget from '../../widget/Widget';
import WidgetAjax from '../../widget/WidgetAjax';
import WidgetRadio from '../../widget/WidgetRadio';
import WidgetMessage from '../../widget/WidgetMessage';
import WidgetProgress from '../../widget/WidgetProgress';

class CareerEvaluationTest extends React.Component 
{
    constructor(props)
    {
        super(props);

        const { item = {} } = props.location?.state || {}; 

        this.state = {
            basePath: Config.getBasePath(),
            sourcePath: Config.getSourcePath(),
            item:item,
            data:[],
            total:0,
            current:0
        }
    }

    componentDidMount()
    {
        const { item } = this.state;

        if( item && item.id )
        {
            this.loadData();
        }
    }

    loadData = () => {

        const { item, basePath } = this.state;

        let params = {
            test_id: item.id
        }

        const onLoadData = (result, params ) => {

            if( result.status===0 )
            {
                
                if( result.results && result.results.length>0 )
                {
                   
                    for(let item of result.results)
                    {
                        if( item.options )
                        {
                            let radioOptions = [];
                            for(let option of item.options)
                            {
                                radioOptions.push({label:option, value:option});
                            }

                            item["radioOptions"] = [...radioOptions];
                        }
                    }
                }
                this.setState({data:result.results, total:result.total});
            }
            else
            {
                WidgetMessage.error(result.message);
            }
        }

        WidgetAjax.ajax({url:basePath + "/career/test_questions", params:params, callback:onLoadData}, this.props);

    }

    notify = (node, item) => {

        let { answers = {} } = this.state;

        answers[item.id] = node.target.value;

        this.setState({answers:answers, current: Object.keys(answers).length});
    }

    submitQuestion = () => {

        const { answers, item, basePath } = this.state;

        let answer = [];
          
        this.form.validateFields().then((values) => {

            for(let key in answers)
            {
                answer.push({questionid:key, answer:answers[key]});
            }

            let params = {
                test_id:item.id,
                answer:answer
            }

            const onSubmitQuestion = (result, params ) => {
                
                if( result.status===0 )
                {
                    WidgetMessage.success("职业测评回答成功！");
                }
                else
                {
                    WidgetMessage.error(result.message);
                }
            }

            WidgetAjax.ajax({url:basePath + "/career/test_answer", params:params, callback:onSubmitQuestion}, this.props);
        })
    }

    onFinish = (values) => {
        
        this.submitQuestion();

    };

    
    submit = () => {
        this.form.submit();
    }


    render()
    {
        const { sourcePath, item, data=[], total, current=0, answers={}} = this.state;

        return (
            <div className="sf-page" component-data="career-evaluation-test">
                <div className='sf-career-top' style={{minHeight:905}}>
                    <div className='sf-career-evaluation-test-body'>
                        <div className='sf-career-evaluation-test-content'>
                            <div className='sf-career-evaluation'>
                                <div className='sf-career-evaluation-title'>{item.title}</div>

                                <div className='sf-career-evaluation-item'>
                                    <div className='sf-career-evaluation-completed'>
                                        <img ></img>
                                        <span>请根据对问题的理解，选择合适的答案选项</span>
                                    </div>
                                    <div className='sf-career-evaluation-duration'>
                                        <div>共<span>{item.completed}</span>题，预计用时<span>{item.duration}</span></div>
                                        <div>
                                            <WidgetProgress total={total} current={current}></WidgetProgress>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='sf-career-evaluation-question'>
                                <Form
                                    ref={ref => this.form = ref}
                                    layout="vertical"
                                    onFinish={this.onFinish}
                                    scrollToFirstError={true}
                                >
                                {
                                    data.map((item, index) => {
                                        let num = index + 1;
                                        let label = num + "、" + item.question;
                                        let name = "question" + item.id;
                                        return (
                                            <Form.Item
                                                name={name}
                                                label={label}
                                                rules={[{ required: true, message:"请选择合适的选项" }]}
                                            >
                                                <WidgetRadio value={answers[item.id]} options={item.radioOptions} onChange={ ( node ) => { this.notify(node, item) }}></WidgetRadio>
                                            </Form.Item>
                                            // <div key={index} className="sf-career-evaluation-question-item">
                                            //     <div className="sf-career-evaluation-question-content">{num}、{item.question} </div>
                                            //     <div className="sf-career-evaluation-question-answer">
                                            //         <WidgetRadio value={answers[item.id]} options={item.radioOptions} onChange={ ( node ) => { this.notify(node, item) }}></WidgetRadio>
                                            //     </div>
                                            // </div>
                                        )
                                    })
                                }
                                </Form>
                            </div>
                        </div>
                        

                        <div className='sf-career-evaluation-question-submit'>
                            <Button onClick={this.submit}>提交</Button>
                        </div>

                       
                    </div>
                </div>
            </div>
        );
    }

}
export default CareerEvaluationTest;